<template>
  <div class="wrap">
    <div class="wrap_logo">
      <img src="../../assets/new/login/logo.png" alt="">
    </div>
    <div class="wrap_title">{{ $t('欢迎') }}</div>
    <div class="apply_tips">
      <div class="tips_bank">
        <img src="../../assets/new/bank.png" alt="">
        <div class="tips_bank_right">
          <div class="right_title">{{ $t('贷款金额') }}</div>
          <!-- <div class="right_userphone">{{ $t('用户账号') }}:{{ userInfo.userphone }}</div> -->
        </div>
      </div>
      <div class="money" v-if="userInfo.loan && (userInfo.loan.status == 0)">
        <div class="money_title">{{ $t('贷款总数') }}</div>
        <div class="money_num">{{ $money((userInfo.loan && userInfo.loan.money) || 0) }}
        </div>
      </div>
      <div class="money" v-else>
        <div class="money_title">{{ $t('Balances') }}</div>
        <div class="money_num">{{ $money(userInfo.money || 0) }}</div>
      </div>
    </div>
    <div class="apply_box">
      <!-- <div class="btn" @click="infoClick">{{ userInfo.auth_level == 2 ? $t('goods.wallet') : $t('goods.completeInfo') }}
      </div> -->
      <div class="read">
        <van-radio-group v-model="readRadio" checked-color="#00bf63">
          <van-radio name="1"></van-radio>
        </van-radio-group>
        <div class="policy" @click="overlayShow = true">{{ $t('goods.policyDepartment') }}</div>
      </div>
    </div>
    <!-- <div class="cont_btn">
      <div class="cont_btn_item" @click="hanldeTo({ path: 'wallet' })">
        <img src="../../assets/new/withdraw.png" alt="">
      </div>
      <div class="cont_btn_item" @click="hanldeTo({ path: '/withdraw-list' })">
        <img src="../../assets/new/history.png" alt="">
      </div>
    </div> -->
    <div class="cont_list">
      <!-- <div class="list" v-for="item, index in list" :key="index" @click="hanldeTo(item)">
        <div class="list_img">
          <img :src="item.img" alt="">
        </div>
        <div class="text">{{ $t(item.text) }}</div>
      </div> -->
      <div class="list">
        <div class="list_img" @click="hanldeTo({ path: 'wallet' })">
          <img src="../../assets/new/withdraw.png" alt="">
        </div>
        <div class="list_img" @click="hanldeTo({ path: '/withdraw-list' })">
          <img src="../../assets/new/history.png" alt="">
        </div>
        <div class="list_img" @click="hanldeTo({ path: '/user' })">
          <img src="../../assets/new/setting.png" alt="">
        </div>
        <div class="list_img" @click="hanldeTo({ path: '/partner' })">
          <img src="../../assets/new/cooperate.png" alt="">
        </div>
        <div class="list_img" @click="hanldeTo({ path: '/repayDetail' })">
          <img src="../../assets/new/repayment.png" alt="">
        </div>
        <div class="list_img" @click="hanldeTo({ path: '/contract' })">
          <img src="../../assets/new/contract.png" alt="">
        </div>
        <div class="list_img" @click="hanldeTo({ path: 'aboutUs' })">
          <img src="../../assets/new/aboutus.png" alt="">
        </div>
        <div class="list_img" @click="logoutEvent">
          <img src="../../assets/new/logout.png" alt="">
        </div>
      </div>
    </div>
    <div class="menu">
      <img src="@/assets/new/index/menu.png" alt="">
    </div>
    <!-- <div class="btns">
      <div class="btns_item" @click="hanldeTo({ path: '/partner' })">
        <img src="@/assets/new/index/cooperate.png" alt="">
        <span>{{ $t('合作') }}</span>
      </div>
      <div class="btns_item" @click="hanldeTo({ path: 'aboutUs' })">
        <img src="@/assets/new/index/about.png" alt="">
        <span>{{ $t('goods.aboutUs') }}</span>
      </div>
    </div> -->
    <!-- <div class="btn" @click="hanldeTo({ path: '/user' })">{{ $t('设置') }}</div> -->
    <van-overlay :show="overlayShow" @click="overlayShow = false" z-index="10" class="about_overlay">
      <div class="wrapper" @click.stop>
        <div v-html="about"></div>
      </div>
    </van-overlay>
    <van-popup v-model="popShow" position="center" class="pop">
      <div class="pop_sign">
        <div class="sign_title">{{ $t('请签名') }}</div>
        <div class="sign_cont">
          <vue-esign ref="esign" :width="400" :height="150" :isCrop="isCrop" :lineWidth="lineWidth"
            :lineColor="lineColor" />
        </div>
        <div class="sing_btn">
          <div class="_btn" @click="handleReset">{{ $t('重签') }}</div>
          <div class="_btn" @click="handleGenerate">{{ $t('user.Button.Two') }}</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast, RadioGroup, Radio, Overlay, Popup,Dialog } from "vant";
import Cookies from "js-cookie";
import verConfig from "@/utils/verConfig";
import { mapGetters } from "vuex";
import vueEsign from 'vue-esign'
import { USERS_EDIT } from "@/api"

export default {
  components: {
    [Toast.name]: Toast,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Overlay.name]: Overlay,
    [Popup.name]: Popup,
    vueEsign,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      popShow: false,
      readRadio: '1',
      list: [{
        img: require('@/assets/new/payment.png'),
        text: 'goods.wallet',
        path: 'wallet'
      },
      //  {
      //   img: require('@/assets/new/index/recharge.png'),
      //   text: 'topUp',
      //   path: '/new-recharge'
      // }, {
      //   img: require('@/assets/new/index/withdrawal.png'),
      //   text: '提现',
      //   path: '/new-withdraw'
      // },
      {
        img: require('@/assets/new/index/transaction.png'),
        text: '交易',
        path: '/withdraw-list'
      },
      {
        img: require('@/assets/new/index/contract.png'),
        text: 'goods.contract',
        path: '/contract'
      },
      {
        img: require('@/assets/new/index/repayment.png'),
        text: 'goods.repayment',
        path: '/repayDetail'
      }, {
        img: require('@/assets/new/index/cooperate.png'),
        text: 'goods.cooperation',
        path: '/partner'
      }, {
        img: require('@/assets/new/index/about.png'),
        text: 'goods.aboutUs',
        path: 'aboutUs'
      },
        // {
        //   img: require('@/assets/new/history.png'),
        //   text: 'goods.history',
        //   path: '/transactionHistory'
        // }, 
        //  {
        //   img: require('@/assets/new/contract.png'),
        //   text: 'goods.contract',
        //   path: '/contract'
        // }, 

      ],
      overlayShow: false,
      lineWidth: 2,
      lineColor: '#000000',
      resultImg: '',
      isCrop: false,
    }
  },
  computed: {
    ...mapGetters(["userInfo", "about"]),
  },
  methods: {
    logoutEvent() {
      let _this = this;
      Dialog.confirm({
        title: this.$t("user.quit"),
        message: this.$t("user.logoutEvent"),
        cancelButtonText: this.$t("user.Button.One"),
        confirmButtonText: this.$t("user.Button.Two"),
      }).then(() => {
        let pwdState = _this.$cookie.get("the-pwd-state");
        let pwdObj = _this.$cookie.get("the-pwd-obj");
        _this.$cookie.clear();
        _this.$cookie.set("the-pwd-state", pwdState);
        _this.$cookie.set("the-pwd-obj", pwdObj);
        _this.$router.push("/login");
      }).catch(() => { });
    },
    handleReset() {
      this.$refs.esign.reset()
    },
    handleGenerate() {
      this.$refs.esign.generate().then(res => {
        this.submitSign(res)
        this.popShow = false;
      }).catch(err => {
        Toast(this.$t('请签名'))
      })
    },
    infoClick() {
      if (this.userInfo.auth_level == 1) {
        return this.hanldeTo({ path: '/question' })
      }
      if (this.userInfo.auth_level == 2) {
        return this.hanldeTo({ path: '/wallet' })
      }
      this.hanldeTo({ path: '/baseInfo' })
    },
    async submitSign(sign_pic) {
      Toast.loading();
      try {
        const res = await USERS_EDIT({ sign_pic });
        Toast.clear();
        this.handleReset();
        this.$store.dispatch('getUserInfo');
        this.infoClick();
      } catch (error) {
        Toast.clear();
        Toast(error.msg);
      }
    },
    hanldeTo(item) {
      if (!item.path) return;
      if (item.path == 'aboutUs') { return this.overlayShow = true };
      if (item.path == 'wallet') {
        if (!this.userInfo.sign_pic) return this.popShow = true;
        this.infoClick();
        return
      }
      if (item.path == '/wallet') {
        if (this.userInfo.auth_level == 1) {
          return this.$router.push('/question');
        }
        if (this.userInfo.auth_level == 2) {
          return this.$router.push('/wallet');
        }
        return this.$router.push('/baseInfo')
      }
      this.$router.push(item.path)
    }
  },
  created() {
    this.$store.dispatch('getUserInfo')
  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
@Color: rgb(222, 140, 23);
@bg: var(--bg);
@sizeColor: var(--sizeColor);
@newBg: #ff004f;

.flex(@JC: center; @FW: nowrap; @AI: center; @FD: row) {
  display: flex;
  flex-wrap: @FW;
  flex-direction: @FD;
  justify-content: @JC;
  align-items: @AI;
}

.text-overflow(@num: 1) {
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: @num;
}

.wrap {
  min-height: 100vh;
  background: var(--bgImg) no-repeat;
  background-size: 100% 100%;

  .wrap_logo {
    margin: calc(40rem / 16) calc(30rem / 16) 0;

    img {
      width: 65px;
      height: 65px;
      display: block;
    }
  }

  .wrap_title {
    margin: calc(10rem / 16) calc(30rem / 16) 0;
    font-size: 18px;
    color: var(--white);
    font-weight: bold;
  }

  .apply_tips {
    background: var(--btnColor);
    color: var(--white);
    margin: calc(10rem / 16) calc(20rem / 16) 0;
    border-radius: calc(20rem / 16);
    border: 2px solid var(--black);
    padding: calc(10rem / 16);

    .tips_bank {
      display: flex;
      align-items: center;

      img {
        width: 55px;
        height: auto;
        display: block;
      }

      &_right {
        margin-left: 5px;

        .right_title {
          text-transform: uppercase;
          font-size: 12px;
          color: var(--white);
          font-weight: bold;
        }

        .right_userphone {
          color: var(--white);
          font-size: 12px;
          font-weight: bold;
          margin-top: 10px;
        }
      }
    }

    .money {
      margin-top: 10px;
      color: var(--white);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .money_title {
        font-size: calc(12rem / 16);
        font-weight: 600;
        text-transform: uppercase;
      }

      .money_num {
        font-weight: bold;
        font-size: calc(14rem / 16);
      }
    }

    img {
      height: 150px;
      display: block;
    }
  }

  .apply_box {
    padding-top: calc(10rem / 16);

    .btn {
      height: calc(45rem / 16);
      border-radius: calc(8rem / 16);
      background: #f96;
      color: var(--white);
      font-size: calc(16rem / 16);
      text-align: center;
      line-height: calc(45rem / 16);
    }

    .read {
      font-size: calc(12rem / 16);
      padding: 0 calc(20rem / 16) calc(10rem / 16);
      display: flex;
      align-items: center;
      justify-content: center;

      /deep/ .van-radio__icon {
        display: flex;
        align-items: center;
      }

      /deep/ .van-icon {
        width: calc(16rem / 16);
        height: calc(16rem / 16);
        font-size: calc(12rem / 16);
        line-height: calc(16rem / 16)
      }

      /deep/ .van-radio__label {
        color: var(--white);
        line-height: calc(20rem / 16);
      }

      .policy {
        margin-left: calc(5rem / 16);
        color: var(--black);
        line-height: calc(20rem / 16);
      }
    }
  }

  .cont_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    padding: 20px 0;

    .cont_btn_item {
      img {
        width: 130px;
        height: auto;
        display: block;
      }
    }
  }

  .cont_list {
    display: flex;
    flex-direction: column;
    gap: calc(20rem / 16);
    padding: 0 calc(20rem / 16) calc(16rem / 16);

    .list,
    .lists {
      display: flex;
      align-items: center;
      // justify-content: center;
      gap: 10px 20px;
      background: var(--btnColor);
      border-radius: 27px;
      flex-wrap: wrap;
      padding: 10px 20px;

      .list_img {
        width: calc((100% - 40rem / 16) / 3);

        img {
          // width: calc(35rem / 16);
          width: auto;
          height: 70px;
          display: block;
          // margin-right: calc(5rem / 16);
        }
      }

      .text {
        margin-top: calc(8rem / 16);
        color: #36527f;
        font-size: calc(12rem / 16);
        text-align: center;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 0.5px;
      }
    }
  }

  .menu {
    padding: 0 calc(6rem / 16);
    overflow: hidden;
    padding-bottom: 30px;

    img {
      border-radius: calc(5rem / 16);
      width: 100%;
      display: block;
    }
  }

  .btn {
    margin: calc(20rem / 16) calc(20rem / 16) calc(20rem / 16);
    background: var(--btnColor);
    color: var(--btnsizeColor);
    font-weight: 600;
    height: calc(52rem / 16);
    line-height: calc(52rem / 16);
    text-align: center;
    border-radius: calc(100rem / 16);
    box-shadow: 3px 4px 1px #1C2E4C, inset 0px 3px 2px 0px #FFF1C8;
  }

  .btns {
    padding: calc(20rem / 16);
    display: flex;
    gap: calc(20rem / 16);

    .btns_item {
      flex: 1;
      min-height: calc(135rem / 16);
      background: var(--btnColor);
      border-radius: calc(10rem / 16);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      img {
        height: calc(50rem / 16);
        display: block;
      }

      span {
        color: var(--btnsizeColor);
        font-weight: 600;
        font-size: calc(16rem / 16);
        margin-top: calc(5rem / 16);
      }
    }
  }

  .about_overlay {
    display: flex;
    align-items: center;

    .wrapper {
      padding: calc(10rem / 16);
      background-color: var(--white);
      margin: auto;
      max-height: calc(100% - 150rem / 16);
      width: 80%;
      overflow: hidden;
      overflow-y: scroll;

      /deep/ img {
        max-width: 100%;
        height: auto;
        display: block;
      }
    }
  }

  .pop {
    border-radius: 27px;
    background: linear-gradient(180deg, #05879F 0%, rgba(216, 216, 216, 0) 100%);
    width: 100%;

    .pop_sign {
      .sign_title {
        padding: calc(16rem / 16) 0;
        text-align: center;
        color: var(--white);
        font-weight: 700;
      }

      .sign_cont {
        margin: 0 calc(12rem / 16) calc(12rem / 16);
        border: 1px solid var(--black);
        border-radius: calc(27rem / 16);
        background: var(--white);
        overflow: hidden;
      }

      .sing_btn {
        display: flex;
        padding: 0 calc(12rem / 16) calc(12rem / 16);
        align-items: center;
        justify-content: space-between;

        ._btn {
          display: flex;
          align-items: center;
          font-size: calc(14rem / 16);
          color: var(--white);
          background: #ff3131;
          padding: calc(6rem / 16) calc(10rem / 16);
          border-radius: calc(5rem / 16);
        }
        ._btn:last-child{
          background: #094ba0;
        }
      }
    }
  }
}
</style>
